import { FONT, FontStyleSheet } from '../font-style-sheets';
import { PrintCardMenu } from './print-card-menu';

export class OGKushPrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Poppins.Bold_700, FONT.Poppins.Regular_400, FONT.Poppins.SemiBold_600];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/xay1rsv.css';
  }

  shouldStandardizeDominantStrainType() {
    return false;
  }
}
